var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("toggle-details", {
    attrs: { "data-open-on-init": "true" },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (ref) {
          var opened = ref.opened
          var toggle = ref.toggle
          return _c(
            "div",
            { staticClass: "enhancements-overview" },
            [
              _c(
                "div",
                {
                  staticClass: "activator",
                  attrs: {
                    role: "button",
                    "aria-label": "Toggle details",
                    "aria-expanded": opened ? "true" : "false",
                  },
                  on: {
                    click: toggle,
                    enter: toggle,
                    space: function ($event) {
                      $event.preventDefault()
                      return toggle($event)
                    },
                  },
                },
                [
                  _c("div", { staticClass: "enhancements-overview-title" }, [
                    _vm._v(_vm._s(_vm.tc("booking.complementaryPrivilages"))),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("transition", { attrs: { name: "expand-y" } }, [
                opened
                  ? _c(
                      "div",
                      { staticClass: "cart-enhancements-list" },
                      _vm._l(_vm.enhancementsInRoom, function (enhancement) {
                        return _c(
                          "div",
                          {
                            key: enhancement.sitecoreID,
                            staticClass: "cart-enhancement",
                          },
                          [
                            _c("div", { staticClass: "enhancement-title" }, [
                              _vm._v(
                                "\n            " +
                                  _vm._s(enhancement.enhancement.name) +
                                  "\n          "
                              ),
                            ]),
                            _vm._v(" "),
                            enhancement.summary
                              ? _c("div", {
                                  staticClass:
                                    "enhancement-summary section-label",
                                  domProps: {
                                    innerHTML: _vm._s(enhancement.summary),
                                  },
                                })
                              : _vm._e(),
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e(),
              ]),
            ],
            1
          )
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }